(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nb-review-line"] && !Shopify.designMode) return;
  try {
    (function () {
    function addScores() {
      var panels = document.querySelectorAll('.shopify-app-block .yotpo-sr-bottom-line-summary .yotpo-sr-bottom-line-right-panel:not([data-nb-score])');
      for (var i = 0; i < panels.length; i++) {
        var summary = panels[i].closest('.yotpo-sr-bottom-line-summary');
        if (!summary || summary.querySelector('.yotpo-sr-bottom-line-score')) continue;
        var m = (summary.getAttribute('aria-label') || '').match(/^\s*(\d+(?:\.\d+)?)\s+out/);
        if (m) panels[i].setAttribute('data-nb-score', m[1]);
      }
    }
    var t = null;
    function schedule() { if (t) return; t = setTimeout(function () { t = null; addScores(); }, 150); }
    try {
      addScores();
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  })();
  } catch(e) { console.error(e); }
})();

})();
